<template>
  <div class="login">
    <div class="login-content">
      <div class="login-tab">
        <div class="list d-flex align-center justify-between">
          <div
            class="item d-flex align-center justify-center"
            :class="{
              active: currentType === item.type || currentIndex === index
            }"
            v-for="(item, index) in tabs"
            :key="item.type"
            @click="handleChangeTab(item)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
      <!-- 密码登录 -->
      <div class="form-wrap" v-if="currentType === 'login'">
        <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
          <el-form-item>
             <!-- prop="mobile" -->
            <el-input v-model="loginForm.mobile" placeholder="请输入手机号/用户名" ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
       <!--   <el-form-item class="form-item" prop="code">
            <el-input v-model="loginForm.code" placeholder="请输入验证码"></el-input>
            <el-image class="image" src=""></el-image>
          </el-form-item> -->
        </el-form>
        <div
          class="btn d-flex align-center justify-center"
          @click="handleLogin('loginForm')"
        >
          登录
        </div>
        <div class="bottom d-flex align-center justify-between">
          <el-checkbox v-model="checked">记住我</el-checkbox>
          <span @click="handleChangeLogin('loginOnCode')">验证码登录</span>
        </div>
      </div>
      <!-- 账号注册 -->
      <div class="form-wrap" v-if="currentType === 'register'">
        <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
          <el-form-item prop="mobile">
            <el-input v-model="registerForm.mobile" placeholder="请输入手机号" maxlength="11"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="registerForm.password"
              type="password"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
      <!--    <el-form-item class="form-item" prop="code">
            <el-input v-model="registerForm.code" placeholder="请输入验证码"></el-input>
            <el-image class="image" src=""></el-image>
          </el-form-item> -->
          <el-form-item class="form-item">
            <el-input v-model="registerForm.code" placeholder="请输入短信验证码"></el-input>
            <el-button v-show="show1" class="code-btn" type="primary" @click="getCode1" plain>获取验证码</el-button>
            <el-button v-show="!show1" class="code-btn" type="primary" plain>{{ count1 }} s</el-button>
          </el-form-item>
        </el-form>
        <div
          class="btn d-flex align-center justify-center"
          @click="handleRegister('registerForm')"
        >
          注册
        </div>
        <div class="bottom d-flex align-center justify-center">
          <span @click="handleToLogin">返回登录</span>
        </div>
      </div>
      <!-- 验证码登录 -->
      <div class="form-wrap" v-if="currentType === 'loginOnCode'">
        <el-form :model="codeForm" :rules="codeRules" ref="codeForm">
          <el-form-item prop="mobile">
            <el-input v-model="codeForm.mobile" placeholder="请输入手机号" maxlength="11"></el-input>
          </el-form-item>
        <!--  <el-form-item class="form-item" prop="code">
            <el-input v-model="codeForm.code" placeholder="请输入验证码"></el-input>
            <el-image class="image" src=""></el-image>
          </el-form-item> -->
          <el-form-item class="form-item" prop="code">
            <el-input v-model="codeForm.code" placeholder="请输入短信验证码"></el-input>
            <el-button v-show="show" class="code-btn" type="primary" @click="getCode" plain>获取验证码</el-button>
            <el-button v-show="!show" class="code-btn" type="primary" plain>{{ count }} s</el-button>
          </el-form-item>
        </el-form>
        <div
          class="btn d-flex align-center justify-center"
          @click="handleLoginOnCode('codeForm')"
        >
          登录
        </div>
        <div class="bottom d-flex align-center justify-between">
          <el-checkbox v-model="checked">记住我</el-checkbox>
          <span @click="handleChangeLogin('login')">密码登录</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let mobileReg =
  /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
export default {
  name: 'Login',
  data() {
    let validateLoginMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!mobileReg.test(this.loginForm.mobile)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    let validateRegisterMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!mobileReg.test(this.registerForm.mobile)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    let validateLoginCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else if (this.loginForm.code !== this.code) {
        callback(new Error('请输入正确的验证码'))
      } else {
        callback()
      }
    }
    let validateRegisterCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else if (this.registerForm.code !== this.code) {
        callback(new Error('请输入正确的验证码'))
      } else {
        callback()
      }
    }
    return {
      checked: false,
      currentIndex: null,
      show: true,
       count: '',
       timer: null,
       show1: true,
        count1: '',
        timer1: null,
      currentType: 'login',
      code: 'andy',
      codeText: '获取验证码',
      tabs: [
        { title: '用户登录', type: 'login', ref: 'loginForm' },
        { title: '注册', type: 'register', ref: 'registerForm' }
      ],
      loginForm: {
        mobile: '',
        password: '',
        code: ''
      },
      registerForm: {
        mobile: '',
        password: '',
        code: ''
      },
      codeForm: {
        mobile: '',
        code: '',
        mobileCode: ''
      },
      loginRules: {
        mobile: [{ validator: validateLoginMobile, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ validator: validateLoginCode, trigger: 'blur' }]
      },
      codeRules: {},
      registerRules: {
        mobile: [{ validator: validateRegisterMobile, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ validator: validateRegisterCode, trigger: 'blur' }]
      }
    }
  },
  created() {
    if (this.$route.params.type) {
      this.currentType = this.$route.params.type
    }
  },
  methods: {
    handleChangeTab(item) {
      if (item.type === 'register') {
        this.currentIndex = null
      }
      this.currentType = item.type
      this.$nextTick(() => {
        this.$refs[item.ref].resetFields()
      })
    },
    getCode(){
      if(this.codeForm.mobile =='' || this.codeForm.mobile.length!=11){
        alert('请输入11位手机号')
        return
      }
      const url = 'https://trace.hogdata.cn/hogchain-boot/sys/sms';
      this.$http.post(url, {
        mobile: this.codeForm.mobile,
        smsmode: "2"
      }).then(
        response => {
          console.log(response)
          if (response.body.code == 200) {

            // 登陆成功
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
               } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
               }
              }, 1000)
             }
          } else {
            alert(response.body.message);
          }
        },

        response => {
          this.suyuaninfo = ''
          alert(response.body.message);
        },
      );



       },
       // 获取注册验证码

       getCode1(){
         if(this.registerForm.mobile =='' || this.registerForm.mobile.length!=11){
           alert('请输入11位手机号')
           return
         }
         const url = 'https://trace.hogdata.cn/hogchain-boot/sys/sms';
         this.$http.post(url, {
           mobile: this.registerForm.mobile,
           smsmode: "1"
         }).then(
           response => {
             console.log(response)
             if (response.body.code == 200) {
               // 登陆成功
               const TIME_COUNT = 60;
               if (!this.timer1) {
                 this.count1 = TIME_COUNT;
                 this.show1 = false;
                 this.timer1 = setInterval(() => {
                 if (this.count1 > 0 && this.count1 <= TIME_COUNT) {
                   this.count1--;
                  } else {
                   this.show1 = true;
                   clearInterval(this.timer1);
                   this.timer1 = null;
                  }
                 }, 1000)
                }
             } else {
               alert(response.body.message);
             }
           },

           response => {
             this.suyuaninfo = ''
             alert(response.body.message);
           },
         );
          },
    // 账号密码登录
      loginpassword() {
        // 发ajax请求，用以获取数据，此处地址意思是查询 github中 vue 星数最高的项目
				const urlpassword = 'https://trace.hogdata.cn/hogchain-boot/sys/pwdEncrypt';
				this.$http.post(urlpassword, {
					
					captcha: "qulh",
					checkKey: 1639122956126,		
				  password: this.loginForm.password,
				  username: this.loginForm.mobile
				}).then(
				  response1 => {
				    console.log(response1)
				    if (response1.body.code == 200) {
						var password1=response1.body.result.pwd
						
						const url = 'https://trace.hogdata.cn/hogchain-boot/sys/mLogin';
						this.$http.post(url, {
						  password: password1,
						  username: this.loginForm.mobile
						}).then(
						  response => {
						    console.log(response)
						    if (response.body.code == 200) {
						      // 登陆成功
						      console.log(JSON.stringify(response.body.result))
						      localStorage.setItem("logininfo",JSON.stringify(response.body.result));
						       this.$router.push({path: '/home'});
						    } else {
						      alert(response.body.message);
						    }
						  },
						
						  response => {
						    this.suyuaninfo = ''
						    alert(response.body.message);
						  },
						);
				    } else {
				      alert(response1.body.message);
				    }
				  },
				
				  response2 => {
				  },
				);
      },
    // 验证码登录
      logincode() {
        // 发ajax请求，用以获取数据，此处地址意思是查询 github中 vue 星数最高的项目
        const url = 'https://trace.hogdata.cn/hogchain-boot/sys/phoneLogin';
        this.$http.post(url, {
          mobile:this.codeForm.mobile,
          captcha:this.codeForm.code,
        }).then(
          response => {
            console.log(response)
            if (response.body.code == 200) {
              console.log(JSON.stringify(response.body.result))
              localStorage.setItem("logininfo",JSON.stringify(response.body.result));
               this.$router.push({path: '/home'});
              // 登陆成功
            } else {
              alert(response.body.message);
            }
          },

          response => {
            this.suyuaninfo = ''
            alert(response.body.message);
          },
        );
      },

      // 用户注册
        register() {
          let pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}');
          var pas=this.registerForm.password
          if (!pwdRegex.test(pas)){
            alert('密码中必须包含字母（不区分大小写）、数字、特称字符，至少8个字符，最多30个字符')
              return;
          }

          // 发ajax请求，用以获取数据，此处地址意思是查询 github中 vue 星数最高的项目
          const url = 'https://trace.hogdata.cn/hogchain-boot/sys/user/register';
          this.$http.post(url, {
            password: this.registerForm.password,
            phone: this.registerForm.mobile,
            smscode: this.registerForm.code,
            type: "0",
            username: this.registerForm.mobile,
          }).then(
            response => {
              console.log(response)
              if (response.body.code == 200) {
                 // this.$router.push({path: '/home'});
				 this.currentType='login'
                 alert('注册成功')
                // 登陆成功
              } else {
                alert(response.body.message);
              }
            },

            response => {
              this.suyuaninfo = ''
              alert(response.body.message);
            },
          );
        },
    handleChangeLogin(str) {
      let formName = str === 'login' ? 'loginForm' : 'codeForm'
      this.currentType = str
      this.currentIndex = 0
      console.log(str)
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    handleToLogin() {
      this.currentType = 'login'
      this.$nextTick(() => {
        this.$refs['loginForm'].resetFields()
      })
    },
    handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (!valid) {
          return
        }
        this.loginpassword()
      })
    },
    handleLoginOnCode(formName) {
      if(this.codeForm.mobile.length!=11 ||this.codeForm.code.length!=6){
        alert('请输入正确的手机号和验证码！')
        return
      }
      this.logincode()
      // this.$refs[formName].validate((valid) => {
      //   console.log(valid)
      //   if (!valid) {
      //     return
      //   }

      // })
    },
    handleRegister(formName) {
      if(this.registerForm.mobile.length !=11 ||this.registerForm.code.length !=6 ||this.registerForm.password==''){
        alert('请输入正确的注册信息')
        return
      }
      this.register()
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (!valid) {
          return
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  position: relative;
  width: 100vw;
  height: 100vh;
  background: url('../../assets/images/login_bg.jpg') no-repeat;
  background-size: 100% 100%;
  &-content {
    position: absolute;
    top: 50%;
    right: 3.75rem;
    transform: translateY(-50%);
    padding: 0.5rem;
    min-height: 5.625rem;
    background-color: #fff;
    border-radius: 0.125rem;
  }
  &-tab {
    width: 4.375rem;
    height: 0.65rem;
    border-bottom: 0.0125rem solid #eee;
    padding: 0 0.5rem;
    .list {
      height: 100%;
      .item {
        width: 1rem;
        height: 100%;
        font-size: 0.225rem;
        color: #666;
        cursor: pointer;
        &.active {
          position: relative;
          color: #249af3;
          &::after {
            content: '';
            position: absolute;
            bottom: -0.0125rem;
            width: 0.4rem;
            height: 0.025rem;
            background-color: #249af3;
          }
        }
      }
    }
  }
  .form-wrap {
    padding-top: 30px;
    ::v-deep .el-form {
      .el-form-item {
        margin-bottom: 0.25rem;
        .el-form-item__content {
          line-height: 0.5rem;
          font-size: 0.175rem;
          .el-input {
            font-size: 0.175rem;
            .el-input__inner {
              border-radius: 0.1rem;
              border-width: 0.0125rem;
              height: 0.5rem;
              line-height: 0.5rem;
              padding: 0 0.1875rem;
            }
          }
        }
      }
    }
    .form-item {
      ::v-deep .el-form-item__content {
        display: flex;
        align-items: center;
        .image {
          width: 1.375rem;
          cursor: pointer;
          margin-left: 0.125rem;
        }
      }
      .code-btn {
        width: 1.25rem;
        height: 0.5rem;
        padding: 0;
        font-size: 0.15rem;
        border-radius: 0.1rem;
        margin-left: 0.125rem;
      }
    }
  }
  .btn {
    width: 100%;
    height: 0.5rem;
    border-radius: 0.1rem;
    background: linear-gradient(to bottom, #3f87fb, #369ff5 96%, #3a95f8);
    font-size: 0.2rem;
    color: #fff;
    box-shadow: 0 2px 12px 0 rgba(55, 158, 246, 0.5);
    user-select: none;
    cursor: pointer;
    margin: 0.5rem 0 0.1875rem;
    &:active {
      opacity: 0.9;
    }
  }
  .bottom {
    ::v-deep .el-checkbox {
      color: #999;
      .el-checkbox__input {
        .el-checkbox__inner {
          border-radius: 0.025rem;
          border: 0.0125rem solid #e0e0e0;
          width: 0.25rem;
          height: 0.25rem;
          &::after {
            width: 0.05rem;
            height: 0.1rem;
            top: 0.0375rem;
            left: 50%;
            transform: translateX(-50%) rotate(45deg) scaleY(1);
          }
        }
      }
      .el-checkbox__label {
        padding-left: 0.125rem;
        line-height: 0.2375rem;
        font-size: 0.175rem;
      }
    }
    span {
      font-size: 0.175rem;
      color: #999;
      cursor: pointer;
    }
  }
}
</style>
